import Datalist, { DatalistPropsType } from "components/common/datalist/Datalist";
import Translate from "components/common/Translate";
import BooleanView from "components/common/views/BooleanView";
import { uuid } from "config/app-constants";
import { DatalistOnClickType } from "types/datalist-types";
import { SeasonFilterInput, SeasonSortInput, SortEnumType } from "types/graphql";
import { seasonListInfo, SeasonType } from "types/season-type";
import { appendFilters } from "utilities/datalist/datalist-filter-utilities";

type SeasonDatalistPropsType = {
    onItemClick?: DatalistOnClickType<SeasonType>
    name: string,
    fixedFilter?: SeasonFilterInput
}

const SeasonDatalist = (props: SeasonDatalistPropsType) => {
    const options: DatalistPropsType<SeasonType, SeasonFilterInput, SeasonSortInput> = {
        itemId: i => i.id,
        name: props.name || 'season-list',
        dataSource: {
            request: async (params) => {
                let filters = appendFilters(props.fixedFilter, params.filters);
                if(params.searchText) {
                    filters = appendFilters(filters, {
                        or: [
                            {
                                name: {
                                    contains: params.searchText
                                }
                            },
                            {
                                normalizedName: {
                                    contains: params.searchText
                                }
                            }
                        ]
                    })
                }
                const request = await seasonListInfo({
                    order: params.sort,
                    where: filters,
                    skip: params.skip,
                    take: params.take
                });
                return request.data;
            },
            sort: [{
                name: 'name',
                direction: SortEnumType.Desc,
                id: uuid()
            }]
        },
        defaultView: 'table',
        table: {
            columns: [
                {
                    name: 'id',
                    title: <Translate i18nKey="fields.id.name" />
                },
                {
                    name: 'name',
                    title: <Translate i18nKey="fields.name.name" />,
                    resolve(i) {
                        return i.name
                    },
                    sort: {
                        resolve(direction) {
                            return {
                                name: direction
                            }
                        },
                    },
                    card: {
                        group: 'data',
                    }
                },
                {
                    name: 'active',
                    title: <Translate i18nKey="fields.active.name" />,
                    resolve: i => <BooleanView value={i.active} />,
                    sort: {
                        resolve: d => {
                            return {
                                active: d
                            }
                        }
                    },
                    card: {
                        group: 'data',
                    }
                }
            ]
        },
        onItemClick: props.onItemClick,
    };

    return <Datalist {...options} />
}

export default SeasonDatalist;
